import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PageHeader from "components/PageHeader";
import Chart from "./Chart";

function formatCurrency(amount) {
  return `$${amount.toFixed(2)}`;
}

export default function CostManagementPage(props) {
  // const [searchParams, setSearchParams] = useSearchParams();
  // const { nav } = useNavigation();

  // eslint-disable-next-line react/prop-types
  const { groupedCosts } = props;

  const stickyCellStyles = {
    position: "sticky",
    left: 0,
    width: 250,
    borderRight: "2px solid",
    borderRightColor: "grey.300",
  };

  const headerCellStyles = {
    minWidth: 200,
    zIndex: 1,
  };

  const wideheaderCellStyles = {
    width: 450,
  };

  const zebraStripe = {
    backgroundColor: "grey.200",
  };

  if (!groupedCosts) {
    return <Typography variant="body1">Loading...</Typography>;
  }

  return (
    <>
      <PageHeader title="Cost Management" />
      <section>
        <Typography variant="h6">Per-day spend over the last 7 days</Typography>
      </section>

      <TableContainer
        sx={{
          maxHeight: "85vh",
          border: 1,
          borderColor: "grey.300",
          backgroundColor: "white",
        }}
      >
        <Table
          aria-label="Cost table"
          size="small"
          stickyHeader
          sx={{ whiteSpace: "nowrap" }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={stickyCellStyles}>Project</TableCell>
              <TableCell sx={headerCellStyles}>Cost</TableCell>
              <TableCell sx={headerCellStyles}>Budget</TableCell>
              <TableCell sx={wideheaderCellStyles}>&nbsp;</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {groupedCosts &&
              Object.entries(groupedCosts).map(([partnerId, costs], index) => (
                <TableRow
                  key={partnerId}
                  sx={index % 2 === 0 ? zebraStripe : {}}
                >
                  <TableCell sx={stickyCellStyles}>{partnerId}</TableCell>
                  <TableCell sx={headerCellStyles}>
                    {formatCurrency(costs.totalCost)}
                  </TableCell>
                  <TableCell sx={headerCellStyles}>
                    {costs.budget && formatCurrency(costs.budget.amount)}
                  </TableCell>
                  <TableCell>
                    <Chart costs={costs} />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
